import apiUrl from "slices/apiEndpoint";
import React, { useEffect, useRef, useState } from "react";
import Dropzone from "react-dropzone";
import Axios, { AxiosResponse } from "axios";
import Select from "react-select";
import { PatternFormat } from "react-number-format";
import {
  Card,
  Dropdown,
  Pagination,
  Col,
  Container,
  Form,
  Nav,
  Row,
  Tab,
  ProgressBar,
  InputGroup,
  OverlayTrigger,
  Tooltip,
  Spinner,
  Overlay,
  Button,
  Toast,
  Alert,
  Modal,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
  searchHomeOwner,
  getHomeOwnerById,
  sendDocToS3,
  createProject,
  updateProject,
  getSingleProjectById,
  createHomeowner,
} from "../../../../slices/thunk";
import { useSelector, useDispatch } from "react-redux";
//Import Images
import successImg from "../../../../assets/images/success-img.png";
import { jwtDecode } from "jwt-decode";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useTour } from "@reactour/tour";
import { CallAPIGetPromise, blueColor2, primaryColor } from "Common/commaon";
import { Label } from "components/ui/label";
import { FileText, ImageIcon, Loader2, Upload, X } from "lucide-react";
import { Switch } from "components/ui/switch";
import { ProjectFormSkeleton } from "./shimmer";
import api from "Common/api";
import axios from "axios";


interface ProjectDetailsProps {
  projectDetails: any;
  onCreateProject: Function;
  disable: any;
  setHomeOwnerId:any;
  homeOwnerId:any;
  setBluePrintUrl:any;
  bluePrintUrl:any;
  error:any;
  setIsOpen:any;
  setLoading:any;
  setError:any;
  handleCreateProject:any;
  handleUpdateProject:any;
  loading:any;
  isEditDisable:any;
  formData: any; // or a typed FormData interface
  setFormData: (data: any) => void;
  scopeOfWork: string;
  setScopeOfWork: (scope: string) => void;
                                setSteps:any;
}

interface ResponseData {
  message: string;
  result: any;
}
interface JwtPayload {
  userType: string;
}

const ProjectDetails: React.FC<ProjectDetailsProps> = ({
 formData,scopeOfWork,setScopeOfWork,setError,error,setLoading,loading,isEditDisable,
  disable, setIsOpen,setFormData,setHomeOwnerId,homeOwnerId,setBluePrintUrl,handleUpdateProject,handleCreateProject,
                                setSteps,bluePrintUrl
}) => {
  const location = useLocation();
  const { t } = useTranslation(); // ✅ React knows to update
  const token = localStorage.getItem("authUser");
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [filePreview, setFilePreview] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [homeOwnerlaoding,setHomeownerLoading]=useState(false)
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  } else {
    console.error("Token is null");
  }

  const dispatch: any = useDispatch();
  const contractors = useSelector(
    (state: any) => state.Proposal.searchHomeowners
  );
  let project: any = null;
  project = useSelector((state: any) => state.Contract.project);

  const homeOwnerD = useSelector((state: any) => state.Proposal.homeOwnerData);
  const [addagent, setAddagent] = useState<boolean>(false);
 const [homeOnwerSearchEmail,setHomeownerSearchEmail] = useState("")
  const blueprintDoc = useSelector((state: any) => state.Proposal.blueprint);


  const [showHomeownerForm, setShowHomeownerForm] = useState<boolean>(false);
  const [selectedFiles, setselectedFiles] = useState<any>([]);
  const [newHomeowner, setNewHomeowner] = useState<any>([]);
  const [projectId, setProjectId] = useState<any>("");
  const [zipCodeError, setZipCodeError] = useState<any>("");
  const [newErrorApi, setNewErrorApi] = useState("");

  const [notification, setNotification] = useState<{
    status: boolean;
    message: string;
    variant: "success" | "danger" | "warning" | "info";
  } | null>(null);

  useEffect(() => {
    if (project && project.home_owner) {
      setShowHomeownerForm(true);
      setHomeOwnerId(project.home_owner.user_id);
    }
  }, [project]);

  useEffect(() => {
    if (homeOwnerId && formData.email) {
      setShowHomeownerForm(true);
    }
  }, [formData.email, homeOwnerId]);

  useEffect(() => {
    if (!homeOwnerId && formData.email) {
      setHomeownerSearchEmail(formData.email);
    }
  }, [formData.email, homeOwnerId]);

  // if (errorApi && errorApi === "Request failed with status code 400") {
  //   setNewErrorApi("");
  // } else {
  //   setNewErrorApi("");
  // }
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    if (name === "zip" && value.length === 5) {
      getData(value);
    }
    setFormData((prevData:any) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const [pathName, setPathName] = useState(null);

  useEffect(() => {
    if (!location.search) {
      return;
    }

    // Remove the initial "?" from location.search and split by the first "?"
    const queryString = location.search.substring(1);
    const [mainQueryString, nestedQueryString] = queryString.split("?");
    // Parse the main query parameters
    const mainParams: any = new URLSearchParams(mainQueryString);

    // Check if there's a nested query string to parse
    let nestedParams: any = null;
    if (nestedQueryString) {
      nestedParams = new URLSearchParams(nestedQueryString);
    }
    const id = mainParams.get("id") || (nestedParams ? nestedParams.get("id") : null);
    setProjectId(id);
  }, [location.search]);

  const validateProjectDetails = () => {
    const { projectName, country, address, state, zip } = formData;
    if (!projectName || !country || !address || !state || !zip) {
      alert("Please fill in all required fields.");
      return false;
    }
    return true;
  };

  //
  useEffect(() => {
    if (notification && notification.status) {
      const timer = setTimeout(() => {
        setNotification(null);
      }, 5000);

      // Cleanup the timeout if the component unmounts or notification changes
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const handleAlertClick = () => {
    setNotification(null);
  };
  //

  const getData = (zip: any) => {
    setLoading(true);
    axios.get(`${apiUrl}/misc/zipcode/US/${zip}`, )
      .then((resp: any) => {
        const data = resp;
        if (data && data.places && data.places.length > 0) {
          const place = data.places[0];

          setFormData((prevState: any) => ({
            ...prevState,
            city: place["place name"]?.replace("City","").trim(),
            state: place["state abbreviation"],
            country: data["country abbreviation"],
          }));
        } else {
          setZipCodeError("Zip Code not found");
          setNotification({
            status: true,
            message: "Zip Code not found",
            variant: "danger",
          });
          setTimeout(() => {
            setZipCodeError("");
          }, 1000);
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  const handleSearch = () => {
    // Logic to search for the subcontractor
    // If found, setSubContData and set setShowForm to true
    // If not found, handle accordingly
  };
  const handleSelectedValue = async (e: any) => {
    setLoading(true);
    setHomeOwnerId(e);
    try {
      await dispatch(getHomeOwnerById(e));
      setShowHomeownerForm(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching homeowner data:", error);
    }
  };

  const handleAcceptedFiles = (files: any) => {
    setIsLoading(true);
    files.forEach((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setUploadedFile(files[0]);

    dispatch(sendDocToS3("blueprint", files[0]))
      .then((uploadedUrl: any) => {
        if (uploadedUrl) {
          setBluePrintUrl(uploadedUrl);
          setNotification({
            status: true,
            message: "Blueprint Uploaded Successfully",
            variant: "success",
          });
        } else {
          setNotification({
            status: true,
            message: "Blueprint Upload Failed",
            variant: "danger",
          });
        }
      })
      .catch((error: any) => {
        console.error("Error uploading file:", error);
        setNotification({
          status: true,
          message: "Blueprint Upload Failed",
          variant: "danger",
        });
      })
      .finally(() => {
        setselectedFiles(files);
        setIsLoading(false);
      });
  };

  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const formatUSMoneyInput = (value: string) => {
    const normalized = value.replace(/,/g, "");

    if (!/^\d*\.?\d{0,2}$/.test(normalized)) {
      return null;
    }

    const [wholePart, decimalPart] = normalized.split(".");
    const formattedWhole = wholePart
      ? Number(wholePart).toLocaleString("en-US")
      : "";

    if (normalized.includes(".")) {
      return `${formattedWhole}.${decimalPart || ""}`;
    }

    return formattedWhole;
  };

  const normalizeUSMoneyOnBlur = (value: string) => {
    const normalized = value.replace(/,/g, "");

    if (!normalized || Number.isNaN(Number(normalized))) {
      return "";
    }

    return Number(normalized).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const hasFieldError = (fieldName: string) => {
    const fieldErrors: Record<string, string> = {
      projectName: "Project name required",
      zip: "Zip required",
      city: "City required",
      address: "Address required",
      homeowner: "Homeowner details required",
      costOfProject: "Cost of project required",
    };

    return error === fieldErrors[fieldName];
  };

  const getFieldError = (fieldName: string) => {
    return hasFieldError(fieldName) ? error : "";
  };



  const searchHomerownerByEmail = ()=>{
    if(homeOnwerSearchEmail){
      setHomeownerLoading(true)
      CallAPIGetPromise(`/proposal/searchHomeownerByEmail/${homeOnwerSearchEmail}`).then(async (res:any)=>{
if(res.data[0]){
  const id = res.data[0].id
  setHomeOwnerId(id);
  try {
    await dispatch(getHomeOwnerById(id));
    setShowHomeownerForm(true);
    setHomeownerLoading(false);
  } catch (error) {
    setHomeownerLoading(false);
    console.error("Error fetching homeowner data:", error);
  }
}else{
  setHomeownerLoading(false);

  setError('Not any homeowner mathched with your details')
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // optional for smooth animation
  });
setTimeout(() => {
    setError('')
 
}, 5000);
return
}
      })
    }
  
  }
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const fileType = file.type;
      
      // Check if file is PDF or image
      if (fileType.startsWith('image/') || fileType === 'application/pdf') {
        setIsLoading(true);
        setUploadedFile(file);
        
        // Create preview for both images and PDFs
        const reader = new FileReader();
        reader.onloadend = () => {
          setFilePreview(reader.result as string);
          // Simulate upload delay
          setTimeout(() => {
            setIsLoading(false);
          }, 800);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Please upload only PDF or image files');
      }
    }
  };
  useEffect(() => {
    if (contractors.length) {
      const newData = contractors.map((item: any) => {
        return { label: item.user_email, value: item.id };
      });
      setNewHomeowner(newData);
    }
  }, [contractors]);

  useEffect(() => {
    if (homeOwnerD.length && !(new URLSearchParams(location.search).get("sourceJobId") && !projectId)) {
      setFormData((prevState:any) => ({
        ...prevState,
        firstName: homeOwnerD[0].user_first_name,
        lastName: homeOwnerD[0].user_last_name,
        email: homeOwnerD[0].user_email,
        phone: homeOwnerD[0].user_phone,
      }));
    }
  }, [homeOwnerD]);

  // useEffect(() => {
  //   if (blueprintDoc !== "") {
  //     setBluePrintUrl(blueprintDoc);
  //   }
  // }, [blueprintDoc]);

  

  //add agent modal
  const handleShowAgent = () => setAddagent(true);
  const handleCloseAgent = () => {
    formik.resetForm();
    setAddagent(false);
  };
  const handleRemoveFile = () => {
    setUploadedFile(null);
    setFilePreview(null);
    setIsLoading(false);
  };
  const formik: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: "",
      firstName: formData.firstName || "",
      lastName: formData.lastName || "",
      email: formData.email || "",
      contact: formData.phone || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please Enter Your Homeowner Name"),
      lastName: Yup.string().required("Please Enter Your Homeowner Last Name"),
      email: Yup.string()
        .email()
        .matches(/^(?!.*@[^,]*,)/)
        .required("Please Enter Your Homeowner Email"),
      contact: Yup.string().required("Please Enter Your Homeowner contact"),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      setNewErrorApi("");

      try {
        const resp: any = await dispatch(createHomeowner(values));
        let createdHomeowner = resp?.data;
        let homeownerId = createdHomeowner?.id ?? createdHomeowner?.user_id;

        // Keep the flow compatible with API versions that only return a
        // success message by resolving the new ID automatically.
        if (!homeownerId) {
          const searchResp: any = await CallAPIGetPromise(
            `/proposal/searchHomeownerByEmail/${encodeURIComponent(values.email)}`
          );
          createdHomeowner = searchResp?.data?.[0];
          homeownerId = createdHomeowner?.id ?? createdHomeowner?.user_id;
        }

        if (!homeownerId) {
          throw new Error("Unable to select the newly created homeowner");
        }

        setHomeOwnerId(homeownerId);
        setHomeownerSearchEmail(createdHomeowner?.user_email ?? values.email);
        setFormData((prevState: any) => ({
          ...prevState,
          firstName: createdHomeowner?.user_first_name ?? values.firstName,
          lastName: createdHomeowner?.user_last_name ?? values.lastName,
          email: createdHomeowner?.user_email ?? values.email,
          phone: createdHomeowner?.user_phone ?? values.contact,
        }));
        setShowHomeownerForm(true);

        setNotification({
          status: true,
          message: "Homeowner Created Successfully",
          variant: "success",
        });
        setAddagent(false);
        formik.resetForm();
      } catch (err: any) {
        setNewErrorApi(
          err?.response?.data?.error === "Email already exists"
            ? "User already exists with this email"
            : "Unable to add homeowner"
        );
        setAddagent(true);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <React.Fragment>

      {notification && notification.status && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "24px",
            zIndex: 99999,
          }}
        >
          <Alert variant={notification.variant} onClick={handleAlertClick}>
            {notification.message}
          </Alert>
        </div>
      )}

{loading ? <ProjectFormSkeleton /> : <>

<Card className="contract-project-info-card">
      <Card.Body>
        <div className="contract-project-info-header">
        <div>
          <h5 className="card-title mb-1">{t("Project Info")}</h5>
          <p className="text-muted mb-3">
            {t("Add the basic contract/project details. ZIP will auto-fill city, state, and country when available.")}
          </p>
        </div>

        <Button variant="outline-secondary" size="sm" onClick={()=>{
              if(setSteps){
                setIsOpen(true)
                setSteps([
                  {
                    selector: ".step-p",
                    content: t("Step 1: Project Info – Add the basic contract/project details."),
                  },
                  {
                    selector: ".step-m",
                    content: t("Step 2: Milestones – Define and manage payment milestones."),
                  },
	                  {
	                    selector: ".step-home",
	                    content: t("Step 3: Contract – Create, send, download, or sign the contract."),
	                  },
	                  {
	                    selector: ".step-sub",
	                    content: t("Step 4: Subcontractor – Add subcontractors or skip if not needed."),
	                  },
                  {
                    selector: ".step-finish",
                    content: t("Final Step: Review – Check signatures and next actions."),
                  },
                ]);
                
                
              }
            }} className="contract-guide-button">
  <i className="bx bx-book-open align-center me-1"></i> {t("Start Guide")}
</Button>
        </div>

        <div className="contract-project-fields">
        <Row className="g-3 align-items-center mb-3">
          <Col lg={6}>
            <div>
              <Form.Label htmlFor="projectName">
                {t("Project Name")}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">{t("Use a short name that will help everyone recognize this contract.")}</Tooltip>
                  }
                >
                  <Button className="infoButton">?</Button>
                </OverlayTrigger>
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="projectName"
                readOnly={isEditDisable}
                name="projectName"
                placeholder={t("e.g. Kitchen remodel contract")}
                value={formData.projectName}
                onChange={handleInputChange}
                isInvalid={hasFieldError("projectName")}
                required
                disabled={disable}
              />
              {getFieldError("projectName") && (
                <Form.Control.Feedback type="invalid">
                  {t(getFieldError("projectName"))}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>
          <Col lg={6}>
            <div>
              <Form.Label htmlFor="zip">
                {t("ZIP Code")}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      {t("Enter a 5-digit ZIP code. City, state, and country will be filled automatically when found.")}
                    </Tooltip>
                  }
                >
                  <Button className="infoButton">?</Button>
                </OverlayTrigger>
                <span className="text-danger">*</span>
                {zipCodeError !== "" && (
                  <span style={{ color: "red" }}>
                    <b>{t("Zip Code not found")}</b>
                  </span>
                )}
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  id="zip"
                  name="zip"
                  readOnly={isEditDisable}
                  placeholder={t("Enter ZIP")}
                  value={formData.zip}
                  onChange={handleInputChange}
                  isInvalid={hasFieldError("zip")}
                  required
                  maxLength={5}
                  disabled={disable}
                />
              </InputGroup>
              {getFieldError("zip") && (
                <div className="invalid-feedback d-block">
                  {t(getFieldError("zip"))}
                </div>
              )}
            </div>
          </Col>
        </Row>

        <Row className="g-3 align-items-center mb-3">
          <Col lg={12}>
            <div>
              <Form.Label htmlFor="scopeOfWork">{t("Scope of Work")}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                id="scopeOfWork"
                name="scopeOfWork"
                readOnly={isEditDisable}
                placeholder={t("Describe the work that will be completed")}
                value={scopeOfWork}
                onChange={(event) => setScopeOfWork(event.target.value)}
                disabled={disable}
              />
              <Form.Text className="text-muted">{t("Logan can draft this from your chat. Review it before continuing.")}</Form.Text>
            </div>
          </Col>
        </Row>

        <Row className="g-3 align-items-center mb-3">
          <Col lg={12}>
            <div>
              <Form.Label htmlFor="address">
                {t("Project Address")}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">{t("Enter the property address for this contract.")}</Tooltip>
                  }
                >
                  <Button className="infoButton">?</Button>
                </OverlayTrigger>
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="address"
                readOnly={isEditDisable}
                name="address"
                placeholder={t("Enter street address")}
                value={formData.address}
                onChange={handleInputChange}
                isInvalid={hasFieldError("address")}
                required
                disabled={disable}
              />
              {getFieldError("address") && (
                <Form.Control.Feedback type="invalid">
                  {t(getFieldError("address"))}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>
        </Row>

        <Row className="g-3 align-items-center mb-3">
          <Col lg={4}>
            <div>
              <Form.Label htmlFor="city">
                {t("City")}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="city"
                disabled
                placeholder={t("Enter City")}
                value={formData.city}
                onChange={handleInputChange}
                isInvalid={hasFieldError("city")}
                required
              />
              {getFieldError("city") && (
                <Form.Control.Feedback type="invalid">
                  {t(getFieldError("city"))}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <Form.Label htmlFor="state">
                {t("State")}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="state"
                disabled
                name="state"
                placeholder={t("Enter State")}
                value={formData.state}
                onChange={handleInputChange}
                required
              />
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <Form.Label htmlFor="country">
                {t("Country")}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="country"
                disabled
                name="country"
                placeholder={t("Enter Country")}
                value={formData.country}
                onChange={handleInputChange}
                required
              />
            </div>
          </Col>
        </Row>
        </div>
      </Card.Body>
    </Card>

    <Card>
  <Card.Body className="tailwind-prefix">
  <h2 className="text-base mb-1">Client / Homeowner</h2>
  <p className="text-sm text-gray-500 mb-3">Select the homeowner who will receive and sign the contract.</p>
  {getFieldError("homeowner") && (
    <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md p-2 mb-3">
      {t(getFieldError("homeowner"))}
    </div>
  )}
            <div  className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
              <div className="text-sm text-gray-700 leading-relaxed">
              {t(
          "Search for an existing homeowner by email. The homeowner must already be registered with The Tradesmen's Collective or RELiBUILD."
        )}
              </div>
              {!isEditDisable &&
              <div>
     <div className="text-sm text-gray-700 leading-relaxed mt-3">
               {t(
                "If you cannot find the homeowner, add them first, then search again with their email address."
              )}
           
              </div>
                   <Button className="mt-2" variant="secondary" onClick={handleShowAgent}>
                   <i className="bi bi-person-plus align-baseline me-1"></i>{" "}
                   {t("Add Homeowner")}
                 </Button>
              </div>
         
              }
            </div>

    <Row className="g-3 align-items-center mb-3">
 

      
      <Col lg={12} className="tailwind-prefix">


        <div className=" ">
          <div className="">
            {t("Search Homeowner by Email")}
          </div>


<div className="w-full flex flex-col sm:flex-row gap-2 mt-2" >
  <div className={`flex flex-1 border-1 border rounded-md p-2 bg-white ${hasFieldError("homeowner") ? "border-red-300" : "border-gray-300"}`}>
  <input onKeyDown={(e)=>{
    if(e.code==="Enter"||e.code==="NumEnter"){
      searchHomerownerByEmail()

    }
  }}   readOnly={isEditDisable} placeholder="client@example.com" className="outline-none placeholder:text-gray-400  text-sm flex-1 flex border-0 "  value={homeOnwerSearchEmail} onChange={e=>setHomeownerSearchEmail(e.target.value)} type="text" />

  </div>

  <button type="button" disabled={homeOwnerlaoding} style={{
    backgroundColor:primaryColor
  }} onClick={searchHomerownerByEmail} className="flex hover:cursor-pointer items-center text-white justify-center px-4 rounded-md min-h-[42px]">
 {homeOwnerlaoding ? t("Searching...") : t("Search")} 
  </button>
</div>
        </div>
      </Col>
    </Row>

    {showHomeownerForm ? (
      <React.Fragment>
        <p className="mb-5">
          {t("These details are prefilled and can be edited only by a homeowner.")}
        </p>

        <Row className="g-3 align-items-center mb-3 mb-3">
          <Col lg={6}>
            <div>
              <Form.Label htmlFor="firstName">
                {t("First name")}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="firstName"
                name="firstName"
                placeholder={t("Enter First Name")}
                value={formData.firstName}
                onChange={handleInputChange}
                required
                disabled
              />
            </div>
          </Col>
          <Col lg={6}>
            <div>
              <Form.Label htmlFor="lastName">
                {t("Last name")}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="lastName"
                name="lastName"
                placeholder={t("Enter Last Name")}
                value={formData.lastName}
                onChange={handleInputChange}
                required
                disabled
              />
            </div>
          </Col>
        </Row>

        <Row className="g-3 align-items-center">
          <Col lg={6}>
            <div>
              <Form.Label htmlFor="homeOwnerEmail">
                {t("Email address")}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="homeOwnerEmail"
                name="homeOwnerEmail"
                placeholder={t("Enter Email")}
                value={formData.email}
                onChange={handleInputChange}
                required
                disabled
              />
            </div>
          </Col>
          <Col lg={6}>
            <div>
              <Form.Label htmlFor="homeOwnerPhone">
                {t("Phone")}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="homeOwnerPhone"
                name="homeOwnerPhone"
                placeholder={t("Enter Homeowner Phone")}
                value={formData.phone}
                onChange={handleInputChange}
                required
                disabled
              />
            </div>
          </Col>
        </Row>
      </React.Fragment>
    ) : (
      ""
    )}
    <div className=" tailwind-prefix space-y-2 pt-4 ">
            <Label className="text-sm">
              Blueprint / Supporting Documents
            </Label>
            <p className="text-xs text-gray-500 mb-2">
            If available, upload blueprints, plans, or supporting documents for this project.
            </p>
            
            {!uploadedFile ?!isEditDisable ?   (
              <div className="relative">
                    <Dropzone
            
            accept={{
              "application/pdf": [".pdf"],
              "image/png": [".png"],
              "image/jpeg": [".jpg", ".jpeg"],
            }}
            onDrop={(acceptedFiles: any) => {
              if(isEditDisable){
                return
              }
              handleAcceptedFiles(acceptedFiles);
            }}
          >
            {({ getRootProps,getInputProps }: any) => (
              <div
                {...getRootProps()}
              >
                 <input {...getInputProps()} />
                 <label
                  htmlFor="fileUpload"
                  className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-all duration-200 hover:border-gray-400"
                >
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <div className="p-3 bg-white rounded-full shadow-sm">
                      <Upload className="w-6 h-6 text-gray-600" />
                    </div>
                    <div className="text-center">
                      <p className="text-sm text-gray-700">
                        <span className="text-gray-900">Click to upload</span> or drag and drop documents
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        PDF or Image files only
                      </p>
                    </div>
                  </div>
                </label>
              </div>
            )}
          </Dropzone>
                {/* <input
                  type="file"
                  id="fileUpload"
                  accept="application/pdf,image/png,image/jpeg,image/jpg"
                  onChange={handleFileUpload}
                  className="hidden"
                /> */}
          
              </div>
            ):null : isLoading ? (
              <div className="border-2 border-gray-200 border-solid rounded-lg p-6 bg-white">
                <div className="flex flex-col items-center justify-center py-8 space-y-3">
                  <Loader2 className="w-10 h-10 text-blue-600 animate-spin" />
                  <div className="text-center">
                    <div className="text-sm text-gray-900">Uploading file...</div>
                    <div className="text-xs text-gray-500 mt-1">Please wait</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="space-y-3">
                {/* File Info Card */}
                <div className="border-2 border-gray-200 border-solid rounded-lg p-3 bg-white">
                  <div className="flex items-start gap-3">
                    {/* File Icon/Preview Thumbnail */}
                    <div className="flex-shrink-0">
                      {uploadedFile.type.startsWith('image/') && filePreview ? (
                        <div className="w-14 h-14 rounded-lg overflow-hidden border-2 border-gray-200 shadow-sm">
                          <img
                            src={filePreview}
                            alt="Preview"
                            className="w-full h-full object-cover"
                          />
                        </div>
                      ) : (
                        <div className="w-14 h-14 rounded-lg bg-red-50 border-2 border-red-200 flex items-center justify-center">
                          <FileText className="w-7 h-7 text-red-600" />
                        </div>
                      )}
                    </div>

                    {/* File Info */}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-start justify-between gap-2">
                        <div className="flex-1 min-w-0">
                          <p className="text-sm text-gray-900 truncate">
                            {uploadedFile.name}
                          </p>
                          <p className="text-xs text-gray-500 mt-1">
                            {(uploadedFile.size / 1024).toFixed(2)} KB
                          </p>
                          <div className="flex items-center gap-2 mt-1.5">
                            {uploadedFile.type.startsWith('image/') ? (
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-50 text-blue-700 text-xs rounded-full border border-blue-200">
                                <ImageIcon className="w-3 h-3" />
                                Image
                              </span>
                            ) : (
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-red-50 text-red-700 text-xs rounded-full border border-red-200">
                                <FileText className="w-3 h-3" />
                                PDF
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Remove Button */}
                        <Button
                          type="button"
                          variant="ghost"
                          size="sm"
                          onClick={() => {
                            setUploadedFile(null);
                            setFilePreview(null);
                            setIsLoading(false);
                            setBluePrintUrl("")
                          }}

                          className="flex  p-1 items-center text-red-600 bg-red-50 rounded-full transition-all duration-200"
                        >
                          <X className="w-3 h-3" />
                          <div className="text-red-500 text-[11px]">Remove </div>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Full Preview */}
                {bluePrintUrl && (
                  <div className="border-2 border-gray-200 border-solid rounded-lg overflow-hidden bg-gray-50">
                    {uploadedFile.type.startsWith('image/') ? (
                      <div className="p-4">
                        <img
                          src={bluePrintUrl}
                          alt="Full preview"
                          className="w-full h-auto max-h-96 object-contain rounded-lg"
                        />
                      </div>
                    ) : uploadedFile.type === 'application/pdf' ? (
                      <div className="relative">
                        <iframe
                          src={bluePrintUrl}
                          className="w-full h-96 border-0"
                          title="PDF Preview"
                        />
                        <div className="absolute top-3 right-3 bg-gray-900/80 text-white px-2.5 py-1 rounded-md text-xs backdrop-blur-sm">
                          PDF Preview
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
            )}
          </div>
  </Card.Body>
</Card>


<Card>
  <Card.Body>
  <h5 className="card-title mt-3">{t("Cost of project")}</h5>
    <p className="mb-2">
      {t("Project total cost can be changed later. Use US number format, for example 50,000.00.")}
    </p>
    <Row className="g-3 align-items-center mb-3 mb-3">
      <Col lg={12}>
        <div>
          <Form.Label htmlFor="course-title-input">
            {t("Cost of project")}{" "}
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="tooltip-top">
                  {t("Please enter estimated cost of your project using US format, for example 50,000.00.")}
                </Tooltip>
              }
            >
              <Button className="infoButton">?</Button>
            </OverlayTrigger>
            <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            id="costOfProject"
            name="costOfProject"
            placeholder="50,000.00"
            readOnly={isEditDisable}
            value={formData.costOfProject}
            isInvalid={hasFieldError("costOfProject")}
            onChange={(e) => {
              const { name, value } = e.target;
              const formattedValue = formatUSMoneyInput(value);

              if (formattedValue === null) return;

              setFormData((prev: any) => ({
                ...prev,
                [name]: formattedValue
              }));
            }}
            onBlur={(e) => {
              const { name, value } = e.target;

              setFormData((prev: any) => ({
                ...prev,
                [name]: normalizeUSMoneyOnBlur(value)
              }));
            }}
            
            
            required
            disabled={disable}
          />
          {getFieldError("costOfProject") && (
            <Form.Control.Feedback type="invalid">
              {t(getFieldError("costOfProject"))}
            </Form.Control.Feedback>
          )}
        </div>
      </Col>
    </Row>
  </Card.Body>
</Card>


<div className="tailwind-prefix">
<div className=" space-y-3 bg-blue-50 border-2 border-solid border-blue-200 rounded-lg p-4">
            <h2 className="text-base">
              Escrow<span className="text-red-500">*</span>
            </h2>
            <div className="text-sm text-gray-700">
              Would you like to escrow this project? If yes, click the button below.
            </div>
            <div className="flex items-center gap-3 pt-1">
            <div className="form-check form-switch mb-3">
            <Form.Check>
              <Form.Check.Input
                type="checkbox"
                style={{ height: "30px", width: "60px" }}
                role="switch"
                id="escrow"
                name="escrow"
                onChange={handleInputChange}
                checked={formData.escrow}
                disabled={disable || (project && project.p_escrow !== null)}
              />
            </Form.Check>
          </div>
              <Label htmlFor="escrow-toggle" className="text-sm -mt-2 text-gray-900 cursor-pointer font-medium">
                {formData.escrow ? 'Escrow enabled' : 'Enable escrow'}
              </Label>
            </div>
          </div>
</div>



      <div className="d-flex align-items-start gap-3 mt-4 p-3 bg-white border rounded justify-content-end">
        <button
          type="button"
          className="btn btn-primary btn-label right nexttab px-4"
          disabled={disable || loading}
          aria-busy={loading}
          title={disable ? t("Complete your company profile to continue") : undefined}
          onClick={() =>
            projectId? handleUpdateProject() : handleCreateProject()
          }
        >
          {loading && <Spinner size="sm" className="me-2" aria-hidden="true" />}
          {loading ? t("Saving project…") : t("Save & Continue to Milestones")}
        </button>
      </div>

</>}


      <Modal show={addagent} onHide={handleCloseAgent}>
  <Modal.Header closeButton>
    <Modal.Title as="h5" id="addAgentModalLabel">
      {t("Add Home Owner")}
    </Modal.Title>
  </Modal.Header>
  <Form className="tablelist-form" autoComplete="off" onSubmit={formik.handleSubmit}>
    <Modal.Body>
      <div className="mb-3">
        <Form.Label htmlFor="agent-name-input">
          {t("Homeowner First Name")}<span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          id="firstName"
          name="firstName"
          placeholder={t("Enter Homeowner First Name")}
          value={formik.values.firstName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.firstName}
        />
        {formik.errors.firstName && formik.touched.firstName ? (
          <Form.Control.Feedback type="invalid">
            {formik.errors.name}
          </Form.Control.Feedback>
        ) : null}
      </div>
      <div className="mb-3">
        <Form.Label htmlFor="agent-name-input">
          {t("Homeowner Last Name")}<span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          id="lastName"
          name="lastName"
          placeholder={t("Enter Homeowner Last Name")}
          value={formik.values.lastName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.lastName}
        />
        {formik.errors.lastName && formik.touched.lastName ? (
          <Form.Control.Feedback type="invalid">
            {formik.errors.name}
          </Form.Control.Feedback>
        ) : null}
      </div>
      <div className="mb-3">
        <Form.Label htmlFor="email-input">
          {t("Homeowner Email")}<span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="email"
          id="email"
          name="email"
          placeholder={t("Homeowner Enter email")}
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.email}
        />
        {formik.errors.email && formik.touched.email ? (
          <Form.Control.Feedback type="invalid">
            {formik.errors.email}
          </Form.Control.Feedback>
        ) : null}
      </div>
      <div className="mb-3">
        <Form.Label htmlFor="contact-input">
          {t("Homeowner Contact Number")}<span className="text-danger">*</span>
        </Form.Label>
        <PatternFormat
          className="form-control"
          displayType="input"
          id="contact"
          placeholder={t("Enter contact no")}
          name="contact"
          format="##########"
          value={formik.values.contact}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.errors.contact && formik.touched.contact ? (
          <Form.Control.Feedback type="invalid" className="d-block">
            {formik.errors.contact}
          </Form.Control.Feedback>
        ) : null}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseAgent}>
        <i className="bi bi-x-lg align-baseline me-1"></i> {t("Close")}
      </Button>
      <Button type="submit" variant="primary" id="add-btn">
        {t("Add")}
      </Button>
      <p style={{ width: "100%" }}>
        {newErrorApi !== "" ? (
          <span style={{ color: "red", width: "100%" }}>
            <b>{t(newErrorApi)}</b>
          </span>
        ) : (
          ""
        )}
      </p>
    </Modal.Footer>
  </Form>
</Modal>

    </React.Fragment>
  );
};

export default ProjectDetails;
